import React, { useState } from "react";

export const LoaderContext = React.createContext();

function LoaderProvider({ children }) {
  const [loader, setLoader] = useState({
    state: false,
  });
  const [global, setGlobal] = useState("");

  const value = React.useMemo(() => {
    return {
      loader,
      setLoader,
      global,
      setGlobal,
    };
  }, [loader, setLoader, global, setGlobal]);

  return (
    <LoaderContext.Provider value={value}>{children}</LoaderContext.Provider>
  );
}

export default LoaderProvider;
